import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoneyCircle24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoneyCircle24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.75-15.57a.75.75 0 0 0-1.5 0v.405c-.625.08-1.165.262-1.586.598-.65.519-.856 1.269-.856 2.045 0 .95.49 1.607 1.098 2.06.568.422 1.297.712 1.91.956l.012.005c.665.265 1.205.481 1.593.758.352.251.482.481.482.78 0 .482-.232.84-.628 1.106-.416.28-.98.429-1.487.429-.688 0-1.135-.242-1.41-.466a2 2 0 0 1-.364-.4l-.009-.014a.75.75 0 0 0-1.321.71l.663-.35-.663.351.002.002.002.004.004.009.013.022.04.065q.048.079.138.2c.12.157.299.36.547.563.416.34 1.016.666 1.82.77v.533a.75.75 0 0 0 1.5 0v-.609a4 4 0 0 0 1.363-.575c.721-.486 1.29-1.271 1.29-2.35 0-.937-.507-1.57-1.11-2.001-.543-.387-1.237-.663-1.829-.898l-.081-.032c-.659-.262-1.197-.486-1.58-.771-.348-.259-.495-.511-.495-.857 0-.523.131-.745.291-.873.204-.162.633-.32 1.527-.32.761 0 1.228.254 1.5.476a1.7 1.7 0 0 1 .351.392l.007.013a.75.75 0 0 0 1.343-.67l-.674.33.673-.33v-.001l-.001-.002-.002-.004-.005-.01-.012-.023-.04-.069a3 3 0 0 0-.137-.207c-.12-.163-.3-.373-.554-.58a3.63 3.63 0 0 0-1.825-.773zm-3.403 8.622c.663-.351.663-.352.662-.352zm.658-.36"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoneyCircle24Filled);
